import { render } from "./DetailAddSerieButton.vue?vue&type=template&id=1b990c90&scoped=true"
import script from "./DetailAddSerieButton.vue?vue&type=script&lang=js"
export * from "./DetailAddSerieButton.vue?vue&type=script&lang=js"

import "./DetailAddSerieButton.vue?vue&type=style&index=0&id=1b990c90&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b990c90"]])

export default __exports__